import { Pipe, PipeTransform } from '@angular/core';

import { DataService } from 'app/services';

@Pipe({
  name: 'highlightVin',
})
export class HighlightVinPipe implements PipeTransform {
  constructor(private dataService: DataService) {}

  transform(vinNumber: string = ''): any {
    if (!vinNumber) return vinNumber;

    if (vinNumber.length < 8) return `<strong>${vinNumber}</strong>`;
    else {
      const highlightedVin = vinNumber.slice(-8);
      const unhighlightedVin = vinNumber.slice(0, vinNumber.length - 8);
      return `${unhighlightedVin}<strong>${highlightedVin}</strong>`;
    }
  }
}
